import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AcceptedConversationsIcon, TimerIcom } from '../../../assets/icons';
import { splitPriceByThree } from '../../../utils';
import AcceptedConversationsChart from '../../Charts/AcceptedConversationsChart';
import ChosenOperatorBadge from './ChosenOperatorBadge';
import Skeleton from 'react-loading-skeleton';
import useTranslation from 'hooks/useTranslation';

const chartContainerStyle = { width: '100%', height: '200px' };

const mapState = (state) => ({
  weeklyChosenOperator: state.operatorsData.weeklyChosenOperator,
});

const ChosenOperatorBody = () => {
  const { weeklyChosenOperator } = useSelector(mapState);
  const [emptyWeeklyData, setEmptyWeeklyData] = useState(true);
  const { getTranslation } = useTranslation('OPERATORS');
  const { t } = getTranslation();

  useEffect(() => {
    if (Object.keys(weeklyChosenOperator.data).length > 0) {
      setEmptyWeeklyData(false);
    }
  }, [weeklyChosenOperator.data]);

  const renderAvatarSection = (
    <div className='operators__list__chosen__bottom__operatorinfo__avatar flex'>
      <div className='operators__list__chosen__bottom__operatorinfo__avatar__img'>
        {weeklyChosenOperator.loading || emptyWeeklyData ? (
          <Skeleton width='100%' height='100%' borderRadius='50%' />
        ) : (
          <img src={weeklyChosenOperator.data.imageUrl} alt='' />
        )}
      </div>
      <div className='operators__list__chosen__bottom__operatorinfo__avatar__text'>
        <p className='operators__list__chosen__bottom__operatorinfo__avatar__text__name'>
          {weeklyChosenOperator.loading || emptyWeeklyData ? (
            <Skeleton width='100px' />
          ) : (
            weeklyChosenOperator.data.fullName
          )}{' '}
        </p>
        <p className='operators__list__chosen__bottom__operatorinfo__avatar__text__title'>
          {weeklyChosenOperator.loading || emptyWeeklyData ? (
            <Skeleton />
          ) : (
            weeklyChosenOperator.data.position
          )}{' '}
        </p>
      </div>
    </div>
  );
  return (
    <>
      <div className='operators__list__chosen__bottom flex'>
        <div className='operators__list__chosen__bottom__operatorinfo'>
          {renderAvatarSection}
          <div className='operators__list__chosen__bottom__operatorinfo__status flex flex-ai-c flex-wrap'>
            <ChosenOperatorBadge
              name={t('WORKING_HOURS')}
              value={
                weeklyChosenOperator.loading || emptyWeeklyData ? (
                  <Skeleton width='50px' />
                ) : (
                  weeklyChosenOperator.data.workTime
                )
              }
              iconUrl={TimerIcom}
            />
            <ChosenOperatorBadge
              name={t('ACCEPTED_CONVS')}
              value={
                weeklyChosenOperator.loading || emptyWeeklyData ? (
                  <Skeleton width='50px' />
                ) : (
                  splitPriceByThree(
                    weeklyChosenOperator.data.accepted.totalAccepted
                  )
                )
              }
              iconUrl={AcceptedConversationsIcon}
            />
          </div>
        </div>
        <div className='operators__list__chosen__bottom__chart'>
          <div className='operators__list__chosen__bottom__chart__inner grid grid-pi-c'>
            <div id='container' style={chartContainerStyle}>
              {weeklyChosenOperator.loading || emptyWeeklyData ? (
                <Skeleton width='100%' height='200px' />
              ) : (
                <AcceptedConversationsChart
                  acceptedConversations={
                    weeklyChosenOperator.data.acceptedConversations
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChosenOperatorBody;
